import {
  getAllPayrollSummaries,
  createPayrollSummary,
  createAllPayrollSummaries,
  updatePayrollSummary,
  deletePayrollSummary,
} from '@/services/payrollSummary';

const state = {
  payrollSummaries: [],
  processed: false,
};

const getters = {
  getPayrollSummaries(state) {
    return state.payrollSummaries;
  },
  payrollSummaryProcessed(state) {
    return state.processed;
  },
};

const actions = {
  fetchPayrollSummaries({ commit }, params) {
    commit('SET_PROCESSING');
    return new Promise((resolve, reject) => {
      getAllPayrollSummaries(params)
        .then((response) => {
          commit('SET_PAYROLLSUMMARIES', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createPayrollSummary({ commit }, payrollSummary) {
    return new Promise((resolve, reject) => {
      createPayrollSummary(payrollSummary)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createAllPayrollSummaries({ commit }, payrollSummaries) {
    return new Promise((resolve, reject) => {
      createAllPayrollSummaries(payrollSummaries)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePayrollSummary({ commit }, payrollSummary) {
    return new Promise((resolve, reject) => {
      updatePayrollSummary(payrollSummary)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deletePayrollSummary({ commit }, id) {
    return new Promise((resolve, reject) => {
      deletePayrollSummary(id)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_PAYROLLSUMMARIES(state, data) {
    state.payrollSummaries = data;
    state.processed = true;
  },
  SET_PROCESSING(state) {
    state.processed = false;
  },
  SET_PROCESSED(state) {
    state.processed = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
